import { Cancel } from "@gearbox-protocol/deploy-tools-ui";
import { type FC, useCallback } from "react";
import type { Address } from "viem";

export interface AddressOption {
  address: Address;
  name?: string;
}

interface AddressItemProps {
  address: Address;
  name?: string;
  selected?: boolean;
  onSelect?: (address: Address) => void;
}

const AddressItem: FC<AddressItemProps> = props => {
  const { address, name, selected, onSelect } = props;
  return (
    <div
      className="flex flex-row gap-2 px-3 py-1 rounded-md bg-muted hover:bg-input text-input-foreground cursor-pointer transition-colors items-center"
      onClick={() => onSelect?.(address)}
    >
      {!!selected && <Cancel />}
      {name ?? address}
    </div>
  );
};

export interface AddressSelectorProps {
  items: AddressOption[];
  value?: Address;
  onChange?: (address: Address | undefined) => void;
}

export const AddressSelector: FC<AddressSelectorProps> = props => {
  const { items, value, onChange } = props;

  const handleChange = useCallback(
    (address: Address) => {
      if (value) {
        onChange?.(undefined);
      } else if (value !== address) {
        onChange?.(address);
      }
    },
    [onChange, value],
  );

  const item = items.find(item => item.address === value);

  return (
    <div className="flex flex-row gap-2 flex-wrap">
      {item ? (
        <AddressItem
          key={item.address}
          address={item.address}
          name={item.name}
          selected={item.address === value}
          onSelect={handleChange}
        />
      ) : (
        items.map(i => (
          <AddressItem
            key={i.address}
            address={i.address}
            name={i.name}
            selected={i.address === value}
            onSelect={handleChange}
          />
        ))
      )}
    </div>
  );
};
